var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMaryland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.483,
    height: 103.949,
    viewBox: "0 0 202.483 103.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f0a022}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_maryland",
    transform: "translate(-3.25 -978.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    d: "M8.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3940",
    transform: "translate(0 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    d: "M12.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3941",
    transform: "translate(4.08 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    d: "M12.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3942",
    transform: "translate(4.08 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    d: "M12.164 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3943",
    transform: "translate(4.08 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    d: "M12.164 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3944",
    transform: "translate(4.08 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    d: "M12.164 1009.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3945",
    transform: "translate(4.08 32.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3946",
    d: "M15.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3946",
    transform: "translate(8.159 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3947",
    d: "M15.664 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3947",
    transform: "translate(8.159 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3948",
    d: "M15.664 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3948",
    transform: "translate(8.159 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3949",
    d: "M15.664 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3949",
    transform: "translate(8.159 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    d: "M19.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3950",
    transform: "translate(12.239 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    d: "M19.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3951",
    transform: "translate(12.239 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    d: "M19.164 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3952",
    transform: "translate(12.239 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    d: "M22.664 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3953",
    transform: "translate(16.318 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    d: "M22.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3954",
    transform: "translate(16.318 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    d: "M22.664 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3955",
    transform: "translate(16.318 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    d: "M26.164 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3956",
    transform: "translate(20.398 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    d: "M26.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3957",
    transform: "translate(20.398 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    d: "M26.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3958",
    transform: "translate(20.398 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3959",
    d: "M29.664 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3959",
    transform: "translate(24.478 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3960",
    d: "M29.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3960",
    transform: "translate(24.478 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    d: "M29.664 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3961",
    transform: "translate(24.478 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    d: "M33.164 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3962",
    transform: "translate(28.557 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    d: "M33.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3963",
    transform: "translate(28.557 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3964",
    d: "M36.664 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3964",
    transform: "translate(32.637 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    d: "M36.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3965",
    transform: "translate(32.637 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    d: "M40.164 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3966",
    transform: "translate(36.716 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    d: "M40.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3967",
    transform: "translate(36.716 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    d: "M40.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3968",
    transform: "translate(36.716 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    d: "M43.664 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3969",
    transform: "translate(40.796 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    d: "M43.664 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3970",
    transform: "translate(40.796 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    d: "M43.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3971",
    transform: "translate(40.796 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    d: "M43.664 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3972",
    transform: "translate(40.796 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    d: "M47.164 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3973",
    transform: "translate(44.876 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    d: "M47.164 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3974",
    transform: "translate(44.876 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    d: "M47.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3975",
    transform: "translate(44.876 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    d: "M47.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3976",
    transform: "translate(44.876 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    d: "M47.164 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3977",
    transform: "translate(44.876 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    d: "M50.664 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3978",
    transform: "translate(48.955 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    d: "M50.664 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3979",
    transform: "translate(48.955 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    d: "M50.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3980",
    transform: "translate(48.955 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    d: "M50.664 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3981",
    transform: "translate(48.955 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    d: "M50.664 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3982",
    transform: "translate(48.955 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    d: "M50.664 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3983",
    transform: "translate(48.955 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    d: "M54.164 984.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3984",
    transform: "translate(53.035 4.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    d: "M54.164 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3985",
    transform: "translate(53.035 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    d: "M54.164 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3986",
    transform: "translate(53.035 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    d: "M54.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3987",
    transform: "translate(53.035 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    d: "M54.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3988",
    transform: "translate(53.035 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    d: "M54.164 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3989",
    transform: "translate(53.035 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    d: "M54.164 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3990",
    transform: "translate(53.035 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    d: "M57.664 984.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3991",
    transform: "translate(57.114 4.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3992",
    d: "M57.664 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3992",
    transform: "translate(57.114 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3993",
    d: "M57.664 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3993",
    transform: "translate(57.114 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3994",
    d: "M57.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3994",
    transform: "translate(57.114 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3995",
    d: "M57.664 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3995",
    transform: "translate(57.114 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3996",
    d: "M57.664 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3996",
    transform: "translate(57.114 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3997",
    d: "M57.664 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3997",
    transform: "translate(57.114 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3998",
    d: "M57.664 1009.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3998",
    transform: "translate(57.114 32.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    d: "M57.664 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 3999",
    transform: "translate(57.114 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    d: "M57.664 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4000",
    transform: "translate(57.114 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    d: "M57.664 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4001",
    transform: "translate(57.114 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    d: "M57.664 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4002",
    transform: "translate(57.114 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    d: "M61.164 984.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4003",
    transform: "translate(61.194 4.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    d: "M61.164 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4004",
    transform: "translate(61.194 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    d: "M61.164 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4005",
    transform: "translate(61.194 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    d: "M61.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4006",
    transform: "translate(61.194 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    d: "M61.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4007",
    transform: "translate(61.194 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    d: "M61.164 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4008",
    transform: "translate(61.194 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    d: "M61.164 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4009",
    transform: "translate(61.194 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    d: "M61.164 1009.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4010",
    transform: "translate(61.194 32.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4011",
    d: "M61.164 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4011",
    transform: "translate(61.194 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    d: "M61.164 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4012",
    transform: "translate(61.194 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    d: "M61.164 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4013",
    transform: "translate(61.194 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4014",
    d: "M61.164 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4014",
    transform: "translate(61.194 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4015",
    d: "M64.664 984.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4015",
    transform: "translate(65.273 4.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    d: "M64.664 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4016",
    transform: "translate(65.273 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    d: "M64.664 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4017",
    transform: "translate(65.273 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    d: "M64.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4018",
    transform: "translate(65.273 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    d: "M64.664 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4019",
    transform: "translate(65.273 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4020",
    d: "M64.664 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4020",
    transform: "translate(65.273 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4021",
    d: "M64.664 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4021",
    transform: "translate(65.273 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    d: "M64.664 1009.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4022",
    transform: "translate(65.273 32.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    d: "M64.664 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4023",
    transform: "translate(65.273 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    d: "M64.664 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4024",
    transform: "translate(65.273 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    d: "M64.664 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4025",
    transform: "translate(65.273 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    d: "M64.664 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4026",
    transform: "translate(65.273 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    d: "M68.164 984.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4027",
    transform: "translate(69.353 4.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    d: "M68.164 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4028",
    transform: "translate(69.353 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    d: "M68.164 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4029",
    transform: "translate(69.353 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    d: "M68.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4030",
    transform: "translate(69.353 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    d: "M68.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4031",
    transform: "translate(69.353 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    d: "M68.164 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4032",
    transform: "translate(69.353 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    d: "M68.164 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4033",
    transform: "translate(69.353 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    d: "M68.164 1009.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4034",
    transform: "translate(69.353 32.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    d: "M68.164 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4035",
    transform: "translate(69.353 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    d: "M68.164 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4036",
    transform: "translate(69.353 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    d: "M68.164 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4037",
    transform: "translate(69.353 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    d: "M68.164 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4038",
    transform: "translate(69.353 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    d: "M71.664 984.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4039",
    transform: "translate(73.433 4.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    d: "M71.664 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4040",
    transform: "translate(73.433 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    d: "M71.664 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4041",
    transform: "translate(73.433 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4042",
    d: "M71.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4042",
    transform: "translate(73.433 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4043",
    d: "M71.664 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4043",
    transform: "translate(73.433 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4044",
    d: "M71.664 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4044",
    transform: "translate(73.433 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4045",
    d: "M71.664 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4045",
    transform: "translate(73.433 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4046",
    d: "M75.164 981.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4046",
    transform: "translate(77.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4047",
    d: "M75.164 984.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4047",
    transform: "translate(77.512 4.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    d: "M75.164 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4048",
    transform: "translate(77.512 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4049",
    d: "M75.164 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4049",
    transform: "translate(77.512 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4050",
    d: "M75.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4050",
    transform: "translate(77.512 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4051",
    d: "M75.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4051",
    transform: "translate(77.512 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4052",
    d: "M75.164 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4052",
    transform: "translate(77.512 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4053",
    d: "M75.164 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4053",
    transform: "translate(77.512 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4054",
    d: "M75.164 1009.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4054",
    transform: "translate(77.512 32.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4055",
    d: "M75.164 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4055",
    transform: "translate(77.512 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4056",
    d: "M75.164 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4056",
    transform: "translate(77.512 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4057",
    d: "M78.664 988.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4057",
    transform: "translate(81.592 8.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4058",
    d: "M78.664 991.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4058",
    transform: "translate(81.592 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4059",
    d: "M78.664 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4059",
    transform: "translate(81.592 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4060",
    d: "M78.664 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4060",
    transform: "translate(81.592 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4061",
    d: "M78.664 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4061",
    transform: "translate(81.592 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4062",
    d: "M78.664 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4062",
    transform: "translate(81.592 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4063",
    d: "M78.664 1009.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4063",
    transform: "translate(81.592 32.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4064",
    d: "M78.664 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4064",
    transform: "translate(81.592 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4065",
    d: "M78.664 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4065",
    transform: "translate(81.592 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4066",
    d: "M78.664 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4066",
    transform: "translate(81.592 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4067",
    d: "M78.664 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4067",
    transform: "translate(81.592 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4068",
    d: "M78.664 1026.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4068",
    transform: "translate(81.592 53.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4069",
    d: "M82.164 995.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4069",
    transform: "translate(85.671 16.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4070",
    d: "M82.164 998.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4070",
    transform: "translate(85.671 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4071",
    d: "M82.164 1002.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4071",
    transform: "translate(85.671 24.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    d: "M82.164 1005.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4072",
    transform: "translate(85.671 28.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    d: "M82.164 1009.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4073",
    transform: "translate(85.671 32.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    d: "M82.164 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4074",
    transform: "translate(85.671 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    d: "M82.164 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4075",
    transform: "translate(85.671 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4076",
    d: "M82.164 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4076",
    transform: "translate(85.671 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4077",
    d: "M82.164 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4077",
    transform: "translate(85.671 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4078",
    d: "M82.164 1026.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4078",
    transform: "translate(85.671 53.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4079",
    d: "M85.664 1009.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4079",
    transform: "translate(89.751 32.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4080",
    d: "M85.664 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4080",
    transform: "translate(89.751 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    d: "M85.664 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4081",
    transform: "translate(89.751 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4082",
    d: "M85.664 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4082",
    transform: "translate(89.751 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4083",
    d: "M85.664 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4083",
    transform: "translate(89.751 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4084",
    d: "M89.164 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4084",
    transform: "translate(93.831 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    d: "M89.164 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4085",
    transform: "translate(93.831 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4086",
    d: "M89.164 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4086",
    transform: "translate(93.831 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4087",
    d: "M89.164 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4087",
    transform: "translate(93.831 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4088",
    d: "M92.664 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4088",
    transform: "translate(97.91 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4089",
    d: "M92.664 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4089",
    transform: "translate(97.91 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4090",
    d: "M92.664 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4090",
    transform: "translate(97.91 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4091",
    d: "M92.664 1023.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4091",
    transform: "translate(97.91 48.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4092",
    d: "M96.164 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4092",
    transform: "translate(101.99 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4093",
    d: "M96.164 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4093",
    transform: "translate(101.99 40.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4094",
    d: "M96.164 1019.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4094",
    transform: "translate(101.99 44.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4095",
    d: "M99.664 1012.569a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4095",
    transform: "translate(106.069 36.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4096",
    d: "M99.664 1016.069a2.707 2.707 0 1 1-2.707-2.707 2.707 2.707 0 0 1 2.707 2.707z",
    className: "cls-1",
    "data-name": "Path 4096",
    transform: "translate(106.069 40.796)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaryland);
export default __webpack_public_path__ + "static/media/icon-maryland.500b548a62930e4b3914d02ba19eb793.svg";
export { ForwardRef as ReactComponent };